// An iPhone drawn to real proportions (393 x 852 points, iPhone 15/16), with the
// Dynamic Island and the status bar icons. The screen content is laid out at the
// phone's real width and scaled down, so text and the email wrap exactly as on the phone.

import type { ComponentChildren } from 'preact';
import './iphone.css';

export const PHONE_W = 393;
export const PHONE_H = 852;

export function StatusBar() {
  return (
    <div class="iph-bar" aria-hidden="true">
      <span class="iph-time">9:41</span>
      <span class="iph-icons">
        <svg width="19" height="12" viewBox="0 0 19 12">
          <rect x="0" y="7.5" width="3.2" height="4.5" rx="1" />
          <rect x="5.2" y="5" width="3.2" height="7" rx="1" />
          <rect x="10.4" y="2.5" width="3.2" height="9.5" rx="1" />
          <rect x="15.6" y="0" width="3.2" height="12" rx="1" />
        </svg>
        <svg width="17" height="12" viewBox="0 0 17 12">
          <path d="M8.5 2.4c2.4 0 4.6.9 6.3 2.5l1.3-1.3A10.9 10.9 0 0 0 8.5.6C5.6.6 2.9 1.7.9 3.6l1.3 1.3a9 9 0 0 1 6.3-2.5Z" />
          <path d="M8.5 6c1.4 0 2.6.5 3.6 1.4l1.3-1.3A7 7 0 0 0 8.5 4.2c-1.9 0-3.6.7-4.9 1.9l1.3 1.3C5.9 6.5 7.1 6 8.5 6Z" />
          <path d="m8.5 11.4 2.4-2.4a3.4 3.4 0 0 0-4.8 0l2.4 2.4Z" />
        </svg>
        <svg width="27" height="13" viewBox="0 0 27 13">
          <rect x="0.5" y="0.5" width="23" height="12" rx="3.8" fill="none" stroke="currentColor" stroke-opacity="0.35" />
          <rect x="2" y="2" width="20" height="9" rx="2.4" />
          <path d="M25 4.4v4.2c.8-.3 1.4-1.1 1.4-2.1S25.8 4.7 25 4.4Z" fill-opacity="0.4" />
        </svg>
      </span>
    </div>
  );
}

/**
 * A full iPhone, or with `crop` only its top `crop` points, fading out at the bottom.
 * `width` is the drawn width of the screen in px.
 */
export function IPhone({ width = 240, crop, children }: { width?: number; crop?: number; children: ComponentChildren }) {
  const scale = width / PHONE_W;
  const h = Math.round((crop ?? PHONE_H) * scale);
  return (
    <div class={`iph${crop ? ' iph-crop' : ''}`} style={{ '--iph-s': scale, width: `${width}px`, height: `${h}px` }}>
      <div class="iph-screen">
        <div class="iph-inner">
          <StatusBar />
          <div class="iph-content">{children}</div>
        </div>
        <div class="iph-island" aria-hidden="true" />
        {!crop && <div class="iph-home" aria-hidden="true" />}
      </div>
    </div>
  );
}
